export interface RegulationAccordion {
  kidIsOpen: boolean;
  mifidIsOpen: boolean;
  targetIsOpen: boolean;
  theoreticalValueIsOpen: boolean;
}

export const initialRegulationUI: RegulationAccordion = {
  kidIsOpen: false,
  mifidIsOpen: false,
  targetIsOpen: false,
  theoreticalValueIsOpen: false,
};

export interface RegulationUiState {
  [tabId: string]: RegulationAccordion;
}
